import Modal from '@components/013-Modal/Modal.client';
import VideoComponent from '@components/008-VideoComponent/VideoComponent.client';
import getComponentInstanceFor from '@swey/vue-hydration/getComponentInstanceFor';

export default class VideoModal {
	private readonly element: HTMLElement;

	public static domSelectors = {
		playButton: '.c-video-modal__play-button',
		modal: '.c-video-modal__modal',
		video: '.c-video-modal__video'
	};

	private videoListenersInitialized: boolean = false;

	public constructor(element: HTMLElement) {
		this.element = element;
		this.init();
	}

	private init(): void {
		const modal: HTMLElement | null = this.element.querySelector(VideoModal.domSelectors.modal) as HTMLElement;
		const playButton = this.element.querySelector(VideoModal.domSelectors.playButton);

		if (!playButton || !modal) return;

		playButton.addEventListener('click', (): void => {
			this.openModal();
		});

		modal.addEventListener(Modal.events.MODAL_CLOSED, (): void => {
			this.stopVideo();
		});
	}

	protected openModal(): void {
		const modal: HTMLElement | null = this.element.querySelector(VideoModal.domSelectors.modal) as HTMLElement;
		const modalComponent: Modal = getComponentInstanceFor(modal) as Modal;
		const modalPane = modalComponent.getModalPane();
		const video = modalPane.querySelector(VideoModal.domSelectors.video) as HTMLElement;
		const videoComponent: VideoComponent = getComponentInstanceFor(video) as VideoComponent;

		if (modalComponent && videoComponent) {
			modalComponent.openModal();
			videoComponent.openVideo();
		}

		if (!this.videoListenersInitialized) {
			video.addEventListener(VideoComponent.events.VIDEO_ENDED, (): void => {
				this.closeModal();
			});
			this.videoListenersInitialized = true;
		}
	}

	protected closeModal(): void {
		const modal: HTMLElement | null = this.element.querySelector(VideoModal.domSelectors.modal) as HTMLElement;
		const modalComponent: Modal = getComponentInstanceFor(modal) as Modal;

		if (modalComponent) {
			modalComponent.closeModal();
		}
	}

	protected stopVideo(): void {
		const modal: HTMLElement | null = this.element.querySelector(VideoModal.domSelectors.modal) as HTMLElement;
		const modalComponent: Modal = getComponentInstanceFor(modal) as Modal;
		const modalPane = modalComponent.getModalPane();
		const video = modalPane.querySelector(VideoModal.domSelectors.video) as HTMLElement;
		const videoComponent: VideoComponent = getComponentInstanceFor(video) as VideoComponent;

		if (modalComponent) {
			videoComponent.closeVideo();
		}
	}
}
